import * as actionTypes from '../../constants/actionTypes';

export const setContextualSupport = (supportPageKey) => {
  return {
    type: actionTypes.SET_CONTEXTUAL_SUPPORT,
    payload: {
      supportPageKey,
    },
  };
};

export const setContextualSupportVisibility = (visible) => {
  return {
    type: actionTypes.SET_CONTEXTUAL_SUPPORT_VISIBILITY,
    payload: {
      visible,
    },
  };
};

export const unsetContextualSupport = (supportPageKey) => {
  return {
    type: actionTypes.UNSET_CONTEXTUAL_SUPPORT,
    payload: {
      supportPageKey,
    },
  };
};
